/**
 * The merchants' house (the Meridian) (lifted from lantern-water's `prefabs/meridian.js`): the house shell of
 * `house-shell.ts`, type 4, 5.4 × 4.8 m, walls 5.7 m, at the local origin (the house's centre, on its
 * terrace: the placement's `h`). Params: `ivy` (true) and `windowBoxes` (true), the
 * prototype's optional decorations.
 */
import * as THREE from 'three';
import { houseShell } from '../house-shell.ts';
import { flag } from '../kit.ts';
import type { Prefab } from './types.ts';

const model = { width: 5.4, depth: 4.8, height: 5.7, type: 4 } as const;

export const prefab: Prefab = {
  id: 'house_meridian',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    houseShell(ctx, root, 0, 0, model.width, model.depth, model.height, model.type, { ivy: flag(ctx, 'ivy', true), windowBoxes: flag(ctx, 'windowBoxes', true) });
    return { root, sockets: { chimney: [model.width * 0.3, model.height + 2.65, -0.5], lantern: [model.width * 0.47, 2.15, model.depth / 2 + 0.51] } };
  },
};
